import { Injectable } from "@angular/core";
import { BaseConsentService } from "@apps/patient-core/src/app/services/abstracts/consent.service";

@Injectable({
  providedIn: "root",
})
export class ConciergeConsentService extends BaseConsentService {}
